import { render, staticRenderFns } from "./Blog3.vue?vue&type=template&id=396140ac"
import script from "./Blog3.vue?vue&type=script&lang=js"
export * from "./Blog3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports